import { Grid } from 'jrgrid';
import { transferColumns } from '../../utils';
import { pageTransfers } from '../../api';
import Navbar from '../../../../components/Navbar';
import React, { Fragment } from 'react';
import { Loader } from '../../../../components/Loader';
import { Button, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { FilterButtonFilter, FilterButtons } from '../../../Receiving/utils';

export const TransfersEOneSuccessPage = () => {
  const [refresh, setRefresh] = React.useState(false);
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));

  const renderGrid = () => {
    if (refresh) {
      setTimeout(() => {
        setRefresh(false);
      }, 500);
      return <Loader title='Reloading Grid...' />;
    } else {
      const filter = [
        {
          id: 'updateType',
          type: 'string',
          operand: 'and',
          isLike: false,
          value: 'C',
        },
        {
          id: 'updateStatus',
          type: 'string',
          operand: 'and',
          isLike: false,
          value: 'Import Successful',
        },
        // {
        //   id: 'toDeptId',
        //   type: 'number',
        //   operand: 'and',
        //   isLike: false,
        //   value: `${user.currentRole.departmentId}`,
        // },
      ];

      return (
        <Grid
          amount={20}
          columns={transferColumns}
          query={pageTransfers}
          queryName='pageTransfers'
          defaultSortField='updateId'
          globalFilters={filter}
          refresh
        />
      );
    }
  };

  return (
    <Fragment>
      <Navbar />
      <div className='container-fluid'>
        <Row>
          <Col md={9}>
            {/* {transferFilterButtons.map((item, index) => {
              return (
                <Button
                  key={index}
                  className='mt-3 mb-3 ml-2'
                  variant={item.variant}
                  onClick={() => {
                    if (index === 0) setAllDepts(false);
                    if (allDepts) {
                      setGridFilter([item.filter]);
                    } else {
                      setGridFilter([
                        {
                          id: 'toDeptId',
                          type: 'number',
                          operand: 'and',
                          isLike: false,
                          value: `${user.currentRole.departmentId}`,
                        },
                        item.filter,
                      ]);
                    }
                  }}>
                  {item.title}
                </Button>
              );
            })}
            {itAdmin && (
              <Button
                className='mt-3 mb-3 ml-2'
                onClick={() => {
                  setAllDepts(true);
                  setGridFilter([
                    {
                      id: 'updateType',
                      isLike: false,
                      operand: 'and',
                      type: 'string',
                      value: 'C',
                    },
                  ]);
                }}>
                Show All Transfers
              </Button>
            )} */}
          </Col>
          <Col md={3}>
            <h3 className='mt-3 mb-3 ml-2 mr-2 float-right'>Transfers Successful</h3>
          </Col>
        </Row>
        <div className='ml-2 mr-2'>{renderGrid()}</div>
      </div>
    </Fragment>
  );
};
